import React, { Component } from 'react';
import { string } from '../../localization';
import * as sideBarActions from '../../redux/sideBarActions';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import * as signageHelperFunctions from '../../utilities/HelperFunctions/SignageHelperFunctions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import './UploadDialogue.scss';
import { Icons } from '../../utilities';
import {
  TERMS_AND_CONDITIONS_FRANCE,
  TERMS_OF_SERVICE
} from '../../utilities/constants/Constants';

class DropBoxUploadDialog extends Component {
  state = {
    checkedIn: false,
    fileIndex: 0
  };

  componentDidMount() {
    const { dispatchers } = this.props;
    dispatchers.sideBarActions.showLoadingIcon(false);
  }

  handleCheck = () => {
    const { checkedIn } = this.state;
    this.setState({ checkedIn: !checkedIn });
  };

  setFileIndex = () => {
    const { fileIndex } = this.state;
    this.setState({ fileIndex: fileIndex + 1 });
  };

  resetFileIndex = () => {
    this.setState({ fileIndex: 0 });
  };

  handleDropboxUpload = () => {
    const { dispatchers } = this.props;
    dispatchers.sideBarActions.dropBoxSubmit();
  };

  openTermsofUse = () => {
    const { dispatchers } = this.props;
    if (dispatchers.signageHelperFunctions.isFranceAccount()) {
      window.open(TERMS_AND_CONDITIONS_FRANCE);
    } else {
      window.open(TERMS_OF_SERVICE);
    }
  };

  render() {
    const { dispatchers, isLoadingIcon, fileIndex, totalFiles } = this.props;
    const { checkedIn } = this.state;
    const className = `Dailouge-box2-button btn ${
      !checkedIn || isLoadingIcon ? 'btn-disabled ' : 'btn-enabled '
    }${isLoadingIcon ? 'btn-label-color' : ''}`;

    return (
      <div className='Dropbox-dialogue-container Dailouge-box2-main-container Grey-text'>
        <div className='Dailouge-box2-header-conatiner '>
          <div className='upload-import-txt'>
            <img
              style={{ width: 30, height: 30, marginRight: 10 }}
              src={Icons.dropBoxUploadIcon}
              alt='dropBoxUploadIcon'
            />
            <h4>{string.DROPBOX_IMPORT_KEY}</h4>
          </div>

          {/* close button */}
          <div className='Dailouge-box2-termination-conatiner '>
            <button
              type='button'
              style={{ border: 'none', background: 'none' }}
              onClick={() =>
                dispatchers.sideBarActions.showDropboxUploadDialog(false)
              }
            >
              <img
                style={{ width: 20, height: 20 }}
                src={Icons.closeDefault}
                alt='close'
              />
            </button>
          </div>
        </div>

        {/* image description fields */}
        <div className='Dailouge-box2-description'>
          <h7>{string.DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY}</h7>
        </div>

        <p className='Dailouge-box2-check-line'>
          <div className='custom-control custom-checkbox'>
            <input
              type='checkbox'
              className='custom-control-input'
              id='customCheck1'
              checked={checkedIn}
              onChange={this.handleCheck}
            />
            <label className='custom-control-label' htmlFor='customCheck1'>
              <span>
                <span>{string.PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY}</span>
                <button
                  type='button'
                  className='terms-of-use'
                  style={{ outline: 'none' }}
                  onClick={this.openTermsofUse}
                >
                  {string.TERMS_OF_USE}
                </button>
              </span>
            </label>
          </div>
        </p>
        <div className='Dailouge-box2-button-container'>
          {isLoadingIcon ? (
            <span className='loader-container'>
              <img
                className='small'
                src='data:image/gif;base64,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'
                alt=''
              />
              <span className='processing-lbl'>
                {string.formatString(
                  string.DROPBOX_UPLOAD_PROGRESS_KEY,
                  fileIndex + 1,
                  totalFiles.length
                )}
                {/* {string.IMPORTING_KEY} {fileIndex + 1}{' '}
                {string.OF_KEY} {totalFiles.length} */}
              </span>
            </span>
          ) : (
            <div />
          )}
          <button
            type='button'
            className={className}
            onClick={e => this.handleDropboxUpload(e)}
            disabled={!checkedIn || isLoadingIcon}
          >
            {string.UPLOAD_KEY}
          </button>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeTab: state.sideBar.activeSideBarTab,
    uploadDialogueState: state.sideBar.uploadDialogue,
    dropboxUploadDialog: state.sideBar.dropboxUploadDialog,
    isLoadingIcon: state.sideBar.isLoadingIcon,
    fileIndex: state.sideBar.dropboxFileIndex,
    totalFiles: state.sideBar.dropboxfile
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      signageHelperFunctions: bindActionCreators(
        signageHelperFunctions,
        dispatch
      )
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DropBoxUploadDialog);
